// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_Oh8","cls2":"AboutTheAuthorsSection-cls2_W7r AboutTheAuthorsSection-cls1_Oh8"};